import Vue from "vue";
import VueRouter, { Route, RouteConfig } from "vue-router";

const LoginPage = () => import("../views/user_management/LoginPage.vue");
const HomePage = () => import("../views/HomePage.vue");
const RegisterPage = () => import("../views/user_management/RegisterPage.vue");
const DownloadPage = () => import("../views/DownloadPage.vue");
const ConfirmUserPage = () =>
  import("../views/user_management/ConfirmUserPage.vue");
const SubmitPage = () => import("../views/SubmitPage.vue");
const SingleSubmissionsPage = () =>
  import("../views/benchmark/SingleSubmissionPage.vue");
const AdminPanel = () => import("../views/user_management/AdminPanelPage.vue");
const SubmissionsPage = () => import("../views/SubmissionsPage.vue");
const UserSettingsPage = () =>
  import("../views/user_management/UserSettingsPage.vue");
const RequestNewPasswordPage = () =>
  import("../views/user_management/RequestNewPasswordPage.vue");
const ForgotUsernamePage = () =>
  import("../views/user_management/ForgotUsernamePage.vue");
const OverviewPage = () => import("../views/OverviewPage.vue");
const CitationPage = () => import("../views/CitationPage.vue");
const ContactPage = () => import("../views/ContactPage.vue");
const DataProtectionPage = () => import("../views/DataProtectionPage.vue");
const LicensePage = () => import("../views/LicensePage.vue");
const NewsPage = () => import("../views/NewsPage.vue");
const BenchmarkPage = () => import("../views/benchmark/BenchmarkPage.vue");

import { Config } from "@/config";
import axios from "axios";
import { authHeader } from "@/helpers/auth-header";

Vue.use(VueRouter);

// Defined routes
const routes: Array<RouteConfig> = [
  { path: "/", component: HomePage },
  { path: "/login", component: LoginPage },
  { path: "/register", component: RegisterPage },
  { path: "/download", component: DownloadPage },
  { path: "/submit", component: SubmitPage },
  { path: "/activate/:code", component: ConfirmUserPage },
  { path: "/benchmarks", component: BenchmarkPage },
  { path: "/submissions", component: SubmissionsPage },
  { path: "/adminpanel", component: AdminPanel },
  { path: "/submissions/:id", component: SingleSubmissionsPage },
  { path: "/settings", component: UserSettingsPage },
  { path: "/newPassword", component: RequestNewPasswordPage },
  { path: "/forgotUsername", component: ForgotUsernamePage },
  { path: "/overview", component: OverviewPage },
  { path: "/citation", component: CitationPage },
  { path: "/contact", component: ContactPage },
  { path: "/dataprotection", component: DataProtectionPage },
  { path: "/license", component: LicensePage },
  { path: "/news", component: NewsPage },
  { path: "*", redirect: "/" }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
    return { x: 0, y: 0 };
  }
});

// redirect to login page if not logged in and trying to access a restricted page
export const publicPages = [
  "/",
  "/overview",
  "/citation",
  "/contact",
  "/dataprotection",
  "/license",
  "/news",
  "/login",
  "/register",
  "/leaderboard",
  "/activate",
  "/download",
  "/benchmarks",
  "/benchmarks/semseg",
  "/benchmarks/uncertainsemseg",
  "/submissions/",
  "/newPassword",
  "/forgotUsername"
];

export function authRequired(to: Route) {
  return (
    !publicPages.includes(to.path) &&
    !to.path.startsWith("/activate/") &&
    !to.path.startsWith("/submissions/")
  );
}

router.beforeEach((to: Route, from: Route, next) => {
  const loggedIn = localStorage.getItem("user");

  if (authRequired(to)) {
    // Check if token is still valid when accessing private pages
    if (!loggedIn) return next("/login?target=" + to.path);
    axios
      .get(Config.apiUrl + "/user/isTokenValid", { headers: authHeader() })
      .then(() => next())
      .catch(err => next("/login?target=" + to.path));
  } else {
    next();
  }
});

export default router;
